import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Output, OnInit, OnDestroy, DestroyRef, inject, EventEmitter } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbModal, NgbModalConfig, NgbToastModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PolicyService } from '@services/policy.service';
import { RequestService } from '@services/request.service';
import { CoreModule } from 'app/modules/core.module';
import { FormBuilder, Validators } from '@angular/forms';
import { InsuredService } from '@services/insured.service';
import Swal from 'sweetalert2';
import { InformationPersonalComponent } from './information-personal/information-personal.component';
import { PolicyInformationComponent } from './policy-information/policy-information.component';
import { BankAccountFormComponent } from '../bank-account-form/bank-account-form.component';
import { StateDisplayComponent } from 'app/shared/state-display/state-display.component';
import { apiResponse, apiLog, apiError } from 'app/shared/api-response';

@Component({
  selector: 'app-incorporation',
  standalone: true,
  imports: [CoreModule, PolicyInformationComponent, NgbTooltipModule, NgbToastModule, InformationPersonalComponent, BankAccountFormComponent, StateDisplayComponent],
  providers: [PolicyService, RequestService, InsuredService ],
  templateUrl: './incorporation.component.html',
  styleUrls: ['./incorporation.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncorporationComponent {
  @Input() permissions: any
  @Input() insured: any
  @Output() cancel = new EventEmitter<void>()

  private _requestService = inject(RequestService)
  private _insuredService: InsuredService = inject(InsuredService)
  private fb: FormBuilder = inject(FormBuilder)
  private notsave = true
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)


  protected listPolicies = []
  protected showSpinner = true
  protected showToast = false
  protected listGenders: [] = []
  protected listOffices: [] = []
  protected listGroups: [] = []
  protected listBanks: [] = []
  protected listTypeAccount: [] = []
  protected listInsuredTypes: [] = []
  protected documents: [] = []
  protected policyTransfer: any
  protected listTypeComission = ["Junta Directiva", "Comisión Interna"]

  private today = new Date()
  protected dateMin: any
  protected holder: any
  protected findPolicies = true


  public tab: Number = 1
  public personalDataForm: any
  public transferForm: any
  public bankAccountForm: any
  public Toast = Swal.mixin({
    width: 500,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  })


  ngOnInit() {

    this.transferForm = this.fb.group({
      insuredId: [null, Validators.required],
      relationshipId: [null, Validators.required],
      holderId: [null],
      entityId: [null, Validators.required],
      policyId: [null, Validators.required],
      groupId: [null, Validators.required],
      coverageDestinyId: [null, Validators.required],
      capital: [null, Validators.required],
      dateStart: [null, Validators.required],
      voteType: [null, Validators.required],
      voteNumber: [null, Validators.required],
      voteDate: [null, Validators.required],
      voteDetail: [null, Validators.required],
    })

    this.showSpinner = false
    if (this.insured) {
      this.personalDataForm.patchValue(this.insured)
      this.personalDataForm.patchValue({
        gender: this.insured.gender._id,
        birthdate: this.insured.birthdate.split("T")[0]
      })
    }
  }

  changeTabShow(change: any) {
    if (change == 2) {
      this.transferForm.patchValue({ insured: this.personalDataForm.value.rut })
      this.bankAccountForm.patchValue({ insured: this.personalDataForm.value.rut })
    }

    this.tab = change
    if (change == 0) {
      this.cancel.emit()
    }
  }

  saveInsured(event: any) {
    if (event._id) {
      this.transferForm.patchValue({ insuredId: event._id })
      this.tab = 2
      this.cdr.markForCheck()
      return
    }
    this._insuredService.create(event).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        apiResponse(res, 'Asegurado creado')
        this.transferForm.patchValue({ insuredId: res.insured })
        this.tab = 2
        this.cdr.markForCheck()
      },
      error: (err) => apiError(err, 'Error al crear asegurado')
    })
  }

  savePolicyInformation(data: any) {
    this.transferForm.patchValue(data)
    this._requestService.incorporation(this.transferForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => apiResponse(res, 'Incorporación generada'),
      error: (err) => apiError(err, 'Error al generar incorporación')
    })
  }

  saveBankAccount(data: any){
    this._insuredService.saveBankAccount(data).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        apiResponse(res, 'Cuenta bancaria guardada')
        this.tab = 3
        this.cdr.markForCheck()
      },
      error: (err) => apiError(err, 'Error al guardar cuenta bancaria')
    })
  }

}
